// @flow
import React from 'react';

import type { ILayoutEnum } from '../layout';

import { DEFAULT_VC_IMAGE } from '#common/utils/store';

import './style.pcss';

export type Balance = Array<{
  sku: string,
  image_url: string,
  name: string,
  amount: number
}>;

type Props = {
  layout: ILayoutEnum,
  balance?: Balance
}

const UserBalance = ({
  layout,
  balance
}: Props) => (
  <div
    className={`user-balance user-balance--${layout}`}
  >
    {balance && balance.filter(balance => balance.amount > 0).map(item => (
      <div
        key={item.sku}
        className='user-balance__item'
        data-vc-name={item.sku}
      >
        <img
          className='user-balance__image'
          src={item.image_url || DEFAULT_VC_IMAGE}
          alt={`Icon for ${item.name} currency`}
        />
        <span className={`user-balance__vc-amount--${layout}`}>
          {item.amount}
        </span>
      </div>
    ))}
  </div>
);


export default UserBalance;
